<template>
  <div>
    <Header>
      <template #actions>
        <!-- <div :class="search_focused ? 'group-slided': ''"> -->
        <BaseInput
          class="search-input mr-8"
          icon="search"
          v-model="search"
          @focus="search_focused = true"
          @blur="search_focused = false"
          :placeholder="$t('tables.search')"
          :readonly="false"
        />
        <BaseButton
          class="mr-8"
          variant="secondary"
          color="v1-grey-10"
          size="md"
          @click="showFormats = true"
          >{{ $t("stats.clients.export") }}</BaseButton
        >

        <BaseButton
          variant="secondary"
          color="v1-grey-10"
          size="md"
          @click="import_modal = true"
          >{{ $t("stats.clients.import") }}</BaseButton
        >
      </template>
    </Header>

    <SimpleClientsTable
      :clients="filteredClients"
      :views="clients_views"
      :clients_map="clients_map"
    />

    <IQOSModal @backdropClick="showFormats = false" v-if="showFormats">
      <template #title>{{ $t("stats.clients.export") }}</template>
      <div class="v1-grey-3-color qrw-paragraph-md">
        {{ $t("stats.clients.choose_file_type") }}
      </div>
      <template #actions>
        <BaseButton
          class="w-100"
          @click="showFormats = false"
          variant="secondary"
          size="md"
          color="v1-grey-3"
        >
          <a
            :href="`/api/stats/clients/export_xlsx/${cafe._id}`"
            target="_blank"
            class="v1-grey-3-color qrw-input-text"
            @click="showFormats = false"
          >
            Excel (.xlsx)
          </a>
        </BaseButton>

        <BaseButton
          class="w-100"
          variant="secondary"
          size="md"
          color="v1-grey-3"
          @click="exportToCsv()"
          >CSV</BaseButton
        >
      </template>
    </IQOSModal>

    <ImportClientsModal
      @success="onSuccessfulImport"
      @close="import_modal = false"
      v-if="import_modal"
    />
  </div>
</template>

<script>
import SimpleClientsTable from "@/components/stats/SimpleClientsTable.vue";

import StatsAPI from "@/api/stats";

import ImportClientsModal from "@/components/stats/ImportClientsModal.vue";

import { saveAs } from "file-saver";

import DashboardButton from "@/components/DashboardButton.vue";

import BaseModal from "@/components/modals/BaseModal.vue";

import BlackInput from "@/components/BlackInput.vue";

export default {
  data() {
    return {
      clients: [],
      import_modal: false,
      search: null,
      search_focused: false,
      showFormats: false,
      clients_views: {},
      clients_map: {},
    };
  },
  components: {
    SimpleClientsTable,
    ImportClientsModal,
    DashboardButton,
    BlackInput,
    BaseModal,
  },
  methods: {
    exportToCsv() {
      let csv = `№,Ім'я,Номер телефону,Адреса,Бонусний рахунок,Середній чек\n`;

      this.filteredClients.forEach((item, index) => {
        const fields = [
          index + 1,
          item.name,
          item.phone,
          item.address || "?",
          item.bonus_balance || 0,
          item.average_check || 0,
        ];

        csv += fields.map((f) => `"${f}"`).join(",") + "\n";
      });

      const blob = new Blob([csv], {
        type: "text/csv",
      });

      saveAs(blob, `clients-${Date.now()}.csv`);

      this.showFormats = false;

      this.$store.dispatch("auditlog/write", {
        type: "clients_export",
        payload: {
          format: "csv",
        },
      });
    },
    showImportModal() {
      this.import_modal = true;
    },
    onSuccessfulImport() {
      this.$emit("imported");
      this.import_modal = false;
    },
  },
  mounted() {
    StatsAPI.getClients(this.cafe._id).then((data) => {
      this.clients = data.clients;
      this.clients_views = data.views;
      this.clients_map = data.clients_map;
    });
  },
  computed: {
    filteredClients() {
      if (!this.search) return this.clients;

      console.log(this.search);

      const query = this.search.toLowerCase();

      return this.clients.filter((client) => {
        if (client.name && client.name.toLowerCase().includes(query)) {
          return true;
        }

        if (client.phone && client.phone.toLowerCase().includes(query)) {
          return true;
        }

        if (client.address && client.address.toLowerCase().includes(query)) {
          return true;
        }

        return false;
      });
    },
    cafe() {
      return this.$store.state.cafe;
    },
    showBonusBalance() {
      return (
        this.cafe.loyalty &&
        this.cafe.loyalty.cashback_percent &&
        this.cafe.loyalty.terms_agreed
      );
    },
    currency() {
      return this.$store.state.currency;
    },
  },
};
</script>

<style scoped>
.search-input {
  width: 100%;
}

a {
  text-decoration: none;
}
</style>
